import { registerFr } from '../i18n/index.js';

registerFr({}, 'EmptyState'); // the three titles live in the shared vocabulary (common.fr.ts)
